export var TypeBadgeData;
(function (TypeBadgeData) {
    TypeBadgeData["USER"] = "user";
    TypeBadgeData["CUSTOMER"] = "customer";
    TypeBadgeData["TEAM"] = "team";
    TypeBadgeData["ANONYMOUS"] = "anonymous";
    TypeBadgeData["BOT"] = "bot";
})(TypeBadgeData || (TypeBadgeData = {}));
//# sourceMappingURL=type-badge-data.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui-dto/badge/type-badge-data.js
// module id = 414
// module chunks = 14